import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { PushPin } from "@phosphor-icons/react";
import { Heading } from "./NKDaily";

export default function Moderation() {
  const [pinRoom, setPinRoom] = useState("global-ng");
  const [pinText, setPinText] = useState("");
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {}); }, []);

  const pin = async () => {
    if (!pinText.trim()) return;
    try { await api.post("/lobby/pin", { room_id: pinRoom, message: pinText.trim() }); toast.success("Pinned"); setPinText(""); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const mute = async (u) => {
    const minutes = Number(prompt(`Mute ${u.username || u.name} for how many minutes?`, "60"));
    if (!minutes) return;
    try { await api.post("/admin/mute", { user_id: u.user_id, minutes }); toast.success("Muted"); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const filtered = users.filter((u) => !q || (u.username || "").toLowerCase().includes(q.toLowerCase()) || (u.name || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-6">
      <Heading title="Chat & Moderation" subtitle="Global, Nigeria, and Ghana lobby chats. Mute spam, pin season notices." />

      <section className="nk-card p-4">
        <p className="eyebrow mb-3">Pin a notice</p>
        <div className="flex flex-wrap gap-2">
          <select value={pinRoom} onChange={(e) => setPinRoom(e.target.value)} className="bg-nk-bg border border-nk-line px-3 py-2 rounded-sm text-sm">
            <option value="global-ng">Global · Nigeria</option>
            <option value="global-gh">Global · Ghana</option>
            <option value="global">Global</option>
          </select>
          <input value={pinText} onChange={(e) => setPinText(e.target.value)} placeholder="Season notice or call-to-action…"
            className="flex-1 min-w-[200px] bg-nk-bg border border-nk-line px-3 py-2 rounded-sm text-sm" />
          <button onClick={pin} className="px-4 py-2 bg-nk-gold text-nk-bg text-sm font-medium rounded-sm inline-flex items-center gap-2">
            <PushPin size={14} weight="bold" /> Pin
          </button>
        </div>
      </section>

      <section>
        <p className="eyebrow mb-3">Mute a player</p>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search username…"
          className="w-full max-w-md bg-nk-bg border border-nk-line px-3 py-2 rounded-sm text-sm mb-3" />
        <div className="nk-card overflow-x-auto max-h-96 overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="border-b border-nk-line sticky top-0 bg-nk-surface">
              <tr><Th>User</Th><Th>Email</Th><Th>—</Th></tr>
            </thead>
            <tbody>
              {filtered.map((u) => (
                <tr key={u.user_id} className="border-b border-nk-line/40">
                  <td className="px-4 py-2.5">{u.username || u.name}</td>
                  <td className="px-4 py-2.5 text-nk-mute text-xs">{u.email}</td>
                  <td className="px-4 py-2.5">
                    <button onClick={() => mute(u)} className="px-2 py-1 border border-nk-warn text-nk-warn text-xs rounded-sm hover:bg-nk-warn/10">Mute</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

function Th({ children }) {
  return <th className="px-4 py-3 text-left text-[11px] text-nk-mute font-medium uppercase tracking-wider">{children}</th>;
}
